// "Read more" sits inside the sub-category accordion button. Bootstrap's delegated click handler would
// toggle the accordion, and stopping propagation would also break the remote (rails-ujs) link, so
// hide the toggle attribute from Bootstrap just for this click.
document.addEventListener('click', function (e) {
    var viewMore = e.target.closest && e.target.closest('.view-more');
    if (!viewMore) return;

    var toggle = viewMore.closest('[data-bs-toggle="collapse"]');
    if (!toggle) return;

    toggle.removeAttribute('data-bs-toggle');
    setTimeout(function () {
        toggle.setAttribute('data-bs-toggle', 'collapse');
    }, 0);
}, true);

document.addEventListener('turbolinks:load', function () {
    if ($('#permitSelectTab').length === 0) return;

    var categoryDescriptionSelect = '.category-description'
    checkOverflow(categoryDescriptionSelect);

    var permitDescriptionSelect = '.permit-description'
    checkOverflow(permitDescriptionSelect);

    // Web fonts load after first paint and change text widths, so re-measure once they are ready
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(recheckAll);
    }

    // Re-trim when the available width changes
    var resizeTimer;
    $(window).off('resize.permitDescription').on('resize.permitDescription', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(recheckAll, 150);
    });

    // When any accordion opens
    $(document).on('shown.bs.collapse', '.permitCategoryAccordion', function (e) {
        var permitDescriptionSelect = '.permit-description'
        checkOverflow(permitDescriptionSelect);
    });

    // When any department tab is active
    $(document).on('shown.bs.tab', '.department-tab', function (e) {
        var departmentDescriptionSelect = '.department-description'
        checkOverflow(departmentDescriptionSelect);

        var categoryDescriptionSelect = '.category-description'
        checkOverflow(categoryDescriptionSelect);

        var permitDescriptionSelect = '.permit-description'
        checkOverflow(permitDescriptionSelect);
    });
});

function recheckAll() {
    ['.category-description', '.permit-description', '.department-description'].forEach(checkOverflow);
}

function checkOverflow(descriptionSelector) {
    document.querySelectorAll('.description-wrapper').forEach(wrapper => {
        const desc = wrapper.querySelector(descriptionSelector);
        const link = wrapper.querySelector('.view-more');
        if (!desc || !link) return;

        // Hidden (e.g. collapsed accordion) elements can't be measured
        if (desc.getClientRects().length === 0) return;

        if (!desc.dataset.fullText) desc.dataset.fullText = desc.textContent.trim();
        const fullText = desc.dataset.fullText;

        // Reset to the clamped state before measuring
        desc.textContent = fullText;
        desc.classList.remove('word-truncated');
        link.classList.remove('word-truncated');
        link.style.display = '';
        wrapper.style.paddingTop = '';

        // Force a reflow so clamp takes effect
        const overflowing = desc.scrollHeight > desc.clientHeight + 1;
        if (!overflowing) return;

        truncateAtWord(wrapper, desc, link, fullText);
    });
}

// Trim the description to whole words so that "... Read more" fits inside the clamped lines
function truncateAtWord(wrapper, desc, link, fullText) {
    const style = window.getComputedStyle(desc);
    const maxLines = parseInt(style.webkitLineClamp, 10) || 2;
    const marginTop = parseFloat(style.marginTop) || 0;

    // Inline elements ignore vertical margins, so keep the spacing as wrapper padding
    wrapper.style.paddingTop = marginTop + 'px';
    desc.classList.add('word-truncated');
    link.classList.add('word-truncated');

    // Measure one real rendered line instead of guessing from line-height: "normal"
    link.style.display = 'none';
    desc.textContent = 'A';
    const lineHeight = wrapper.getBoundingClientRect().height - marginTop;
    link.style.display = 'inline';

    const words = fullText.split(/\s+/);
    const fits = count => {
        desc.textContent = words.slice(0, count).join(' ').replace(/[\s,;:.\-]+$/, '');
        // "... Read more" is nowrap, so it must start on the last allowed line
        const linkTop = link.getBoundingClientRect().top - wrapper.getBoundingClientRect().top - marginTop;
        return linkTop < lineHeight * (maxLines - 1) + lineHeight / 2;
    };

    let low = 0, high = words.length - 1, best = 0;
    while (low <= high) {
        const mid = Math.floor((low + high) / 2);
        if (fits(mid)) {
            best = mid;
            low = mid + 1;
        } else {
            high = mid - 1;
        }
    }
    fits(best);
}
